module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vuetable', {
    ref: "quoteRequestsTable",
    staticClass: "mg-md",
    attrs: {
      "css": _vm.css,
      "api-url": _vm.url + '/quotes?projectId=' + _vm.$store.state.route.params.projectId,
      "fields": _vm.fields,
      "query-params": {
        sort: '$sort',
        page: '',
        perPage: '$limit'
      },
      "pagination-path": "",
      "no-data-template": _vm.noDataTemplate(this.loading, 'Ei vielä lähetettyjä tarjouspyyntöjä.')
    },
    on: {
      "vuetable:loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "quoteName",
      fn: function(props) {
        return [_c('router-link', {
          staticClass: "ltc-tufts-blue bold-link",
          attrs: {
            "to": _vm.formLinkToQuote(props.rowData, 'bidders.index')
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formatQuoteName(props.rowData.quoteName)) + "\n    ")])]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-actions"
        }, [_c('router-link', {
          staticClass: "btn btn-sm inverse-color pull-right",
          attrs: {
            "to": _vm.formLinkToQuote(props.rowData, 'received-offers.index')
          }
        }, [_c('span', {
          staticClass: "ion ion-eye icon-spacer icon-midnight-blue"
        }), _vm._v(" Näytä tarjoukset\n      ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm inverse-color pull-right",
          on: {
            "click": function($event) {
              _vm.isRemoveModalShown = true, _vm.setSelectedRow(props.rowData.id)
            }
          }
        }, [_c('span', {
          staticClass: "ion ion-trash-a icon-spacer icon-midnight-blue"
        }), _vm._v(" Poista\n      ")])], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-fe14c016"}!./src/app/components/selected-suppliers-vuetable/selected-suppliers-vuetable.html
// module id = 503
// module chunks = 1